import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "mobile_menu_icon",
  "use": "mobile_menu_icon-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"mobile_menu_icon\"><path d=\"M3.333 15h13.334a.836.836 0 0 0 .833-.833.836.836 0 0 0-.833-.834H3.333a.836.836 0 0 0-.833.834c0 .458.375.833.833.833Zm0-4.167h13.334A.836.836 0 0 0 17.5 10a.836.836 0 0 0-.833-.833H3.333A.836.836 0 0 0 2.5 10c0 .458.375.833.833.833Zm-.833-5c0 .459.375.834.833.834h13.334a.836.836 0 0 0 .833-.834.836.836 0 0 0-.833-.833H3.333a.836.836 0 0 0-.833.833Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol